import axios from 'axios';

export const state = {
  selloffers: [],
  loading: false,
  pagination: {
    dir: 'desc',
    limit: 25,
    page: 1,
    sort: 'created_at',
  },
};

export const mutations = {
  setSellOffers(context, selloffers) {
    context.selloffers = selloffers;
    context.loading = false;
  },

  setPagination(context, pagination) {
    context.pagination = pagination;
    context.loading = false;
  },

  setLoading(context, value) {
    context.loading = value;
  },
};

export const actions = {
  async fetchSellOffers({ commit, rootState }, params) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      const query = params ? `?${params}` : '';
      commit('setSellOffers', []);
      commit('setLoading', true);

      const selloffers = await axios.get(`${window.BASE_API.TRADING_PLATFORM}/orderbook/status/selloffers/history${query}`, options)
        .then(response => response.data);

      commit('setSellOffers', selloffers.data);
      commit('setPagination', selloffers.pagination);
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },

  async cancelSellOffersAction({ commit, dispatch, rootState }, data) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };
      commit('setLoading', true);

      data.ids.map(id => axios.delete(`${window.BASE_API.TRADING_PLATFORM}/orderbook/status/selloffers/${id}/`, options)
        .then(response => response.data));

      commit('setLoading', false);
      dispatch('fetchSellOffers');
    } catch (err) {
      commit('setLoading', false);
    }
  },
};

const sellOffersStore = {
  state,
  mutations,
  actions,
};

export default sellOffersStore;



// WEBPACK FOOTER //
// ./src/store/trades/sellOffersStore.js